import BookPageBase from './BookPage' 

export const BookPage = BookPageBase


// WEBPACK FOOTER //
// ./src/routes/BookPage/index.js